export default __webpack_public_path__ + "static/media/23.3c4faf55.png";